module.exports = __webpack_public_path__ + "static/img/Art.1e716de.png";